import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DetalheBaseController } from '../../../helpers';
import { DevedorService } from '../../../services';
import { Subscription } from 'rxjs/Subscription';

@Component({
    templateUrl: 'confirm.edit.component.html',
})

export class ConfirmEditComponent extends DetalheBaseController {
    subDevedor: Subscription;
    constructor(route: ActivatedRoute, private router: Router, private _devedorService: DevedorService) {
        super(route, _devedorService);  
        this.GetEmailsAtivos();
    }

    GetEmailsAtivos() {
     this.subDevedor=   this._devedorService.getDevedorLogado().subscribe(result => {            
            this.model = result;                 
        });   
    }

    VoltarHome() {
        this.router.navigate(['/app/home']);   
    }       
    
    ngOnDestroy() {
        if (this.subDevedor) this.subDevedor.unsubscribe();
        super.ngOnDestroy();
    }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/confirm/edit/confirm.edit.component.ts